// trigger build
import { pdfjs } from 'react-pdf';
import { QueryClient, QueryClientProvider } from 'react-query';

import Book from 'views/Book';
import BookLayout from 'views/BookLayout';
import MinimalBook from 'views/MinimalBook';
import Uploader from 'views/Uploader';

import GlobalStyle from 'styles/global';

import 'styles/custom.css';
import 'styles/responsive.css';

// De pdf.js worker wordt van onze eigen origin geladen i.p.v. unpkg.com. Het bestand wordt vóór
// start/build gekopieerd uit de pdfjs-dist die bij react-pdf hoort (scripts/copyPdfWorker.js),
// zodat de versie altijd overeenkomt met pdfjs.version.
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.js`;

const queryClient = new QueryClient();

function App() {
  const layoutQuery = new URLSearchParams(window.location.search);
  const layout = layoutQuery.get('layout');

  const renderLayout = () => {
    switch (layout) {
      case 'book':
        return <Book />;
      case 'booklayout':
        return <BookLayout />;
      case 'minimal-book':
        return <MinimalBook />;
      default:
        return <Uploader />;
    }
  };

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <GlobalStyle />
        {renderLayout()}
      </QueryClientProvider>
    </>
  );
}

export default App;
